import React, { useEffect, useState } from "react";
import "./footer.scss";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import { currentDomain } from "../../utils/general-config";
import PdfSimpliFooter from "./ps";
import SignSimpliFooter from "./ss";
import ResumeBuildFooter from "./rb";
import LegalSimpliFooter from "./ls";
import { DomainEnum } from "../../services/enum/environment-enum";
import { APP_NAVIGATION } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";
const Footer = () => {
  const { locale } = useParams();
  const { t } = useTranslation();
  const domain = currentDomain().toLowerCase();
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [termsOfUse, setTermsOfUse] = useState("");
  const [contactUs, setContactUs] = useState("");

  const setUrls = (policy, terms, contact) => {
    setPrivacyPolicy(policy);
    setTermsOfUse(terms);
    setContactUs(contact);
  };

  let contactLinkOption = PathHelper(APP_NAVIGATION.CNTC, false);
  let privacyLinksOption = PathHelper(APP_NAVIGATION.PRVY, false);
  let termsAndConditionOption = PathHelper(APP_NAVIGATION.TUSE, false);

  useEffect(() => {
    //const getUrl = (localeKey, defaultKey) => (locale ? localeKey.replace(":locale", locale) : defaultKey);
    setUrls(privacyLinksOption.cstm, termsAndConditionOption.cstm, contactLinkOption.cstm);

    // switch (domain) {
    //   case DomainEnum.PDFSIMPLI:
    //     setUrls(
    //       getUrl(ROUTE_CONSTANT.PS_POLICY_LOCALE, ROUTE_CONSTANT.PS_POLICY),
    //       getUrl(ROUTE_CONSTANT.PS_TERMS_LOCALE, ROUTE_CONSTANT.PS_TERMS),
    //       getUrl(ROUTE_CONSTANT.PS_CONTACT_LOCALE, ROUTE_CONSTANT.PS_CONTACT)
    //     );
    //     break;
    //   case DomainEnum.RESUMEBUILD:
    //     setUrls(privacyLinksOption.next, termsAndConditionOption.next, contactLinkOption.next);
    //     break;
    //   case DomainEnum.LEGALSIMPLI:
    //     setUrls(
    //       getUrl(ROUTE_CONSTANT.LS_POLICY_LOCALE, ROUTE_CONSTANT.LS_POLICY),
    //       getUrl(ROUTE_CONSTANT.LS_TERMS_LOCALE, ROUTE_CONSTANT.LS_TERMS),
    //       getUrl(ROUTE_CONSTANT.LS_CONTACT_LOCALE, ROUTE_CONSTANT.LS_CONTACT)
    //     );
    //     break;
    //   case DomainEnum.SIGNSIMPLI:
    //     setUrls(
    //       getUrl(ROUTE_CONSTANT.SS_POLICY_LOCALE, ROUTE_CONSTANT.SS_POLICY),
    //       getUrl(ROUTE_CONSTANT.SS_TERMS_LOCALE, ROUTE_CONSTANT.SS_TERMS),
    //       getUrl(ROUTE_CONSTANT.SS_CONTACT_LOCALE, ROUTE_CONSTANT.SS_CONTACT)
    //     );
    //     break;
    //   default:
    //     break;
    // }
  }, [locale, domain]);

  switch (domain) {
    case DomainEnum.PDFSIMPLI:
      return <PdfSimpliFooter privacyPolicy={privacyPolicy} termsOfUse={termsOfUse} contactUs={contactUs} />;
    case DomainEnum.RESUMEBUILD:
      return <ResumeBuildFooter privacyPolicy={privacyPolicy} termsOfUse={termsOfUse} contactUs={contactUs} />;
    case DomainEnum.LEGALSIMPLI:
      return <LegalSimpliFooter privacyPolicy={privacyPolicy} termsOfUse={termsOfUse} contactUs={contactUs} />;
    case DomainEnum.SIGNSIMPLI:
      return <PdfSimpliFooter privacyPolicy={privacyPolicy} termsOfUse={termsOfUse} contactUs={contactUs} />;
    case DomainEnum.WORKSIMPLI:
      return <PdfSimpliFooter privacyPolicy={privacyPolicy} termsOfUse={termsOfUse} contactUs={contactUs} />;
    default:
      return null;
  }
};

export default Footer;
